import { HomeCard } from '@fullstory/proto/fs/services/dx-objects';

export const DEFAULT_CARD_FORMAT = HomeCard.Format.FORMAT_MEDIUM;
export const DEFAULT_DIMENSIONALITY_CARD_FORMAT = HomeCard.Format.FORMAT_MEDIUM;
export const DEFAULT_FUNNEL_CARD_FORMAT = HomeCard.Format.FORMAT_MEDIUM;
export const DEFAULT_HEATMAP_CARD_FORMAT = HomeCard.Format.FORMAT_MEDIUM;
export const DEFAULT_SINGLE_NUMBER_CARD_FORMAT = HomeCard.Format.FORMAT_SMALL;
export const DEFAULT_SEGMENT_CARD_FORMAT = HomeCard.Format.FORMAT_SMALL;
export const DEFAULT_TRENDS_CARD_FORMAT = HomeCard.Format.FORMAT_MEDIUM;
export const PLAYLIST_CARD_WITH_ERROR_PAGE_SIZE = 4;
export const PLAYLIST_CARD_PAGE_SIZE = 5;

export const DEFAULT_FUNNEL_CHART_TYPE = HomeCard.ChartType.CHART_TYPE_BAR_CHART;
export const DEFAULT_RETENTION_CHART_TYPE = HomeCard.ChartType.CHART_TYPE_LINE_CHART;
export const DEFAULT_SEGMENT_CHART_TYPE = HomeCard.ChartType.CHART_TYPE_SINGLE_NUMBER;
export const DEFAULT_SINGLE_NUMBER_CHART_TYPE = HomeCard.ChartType.CHART_TYPE_SINGLE_NUMBER;
export const DEFAULT_DIMENSIONALITY_CHART_TYPE = HomeCard.ChartType.CHART_TYPE_BAR_CHART;
export const DEFAULT_TREND_CHART_TYPE = HomeCard.ChartType.CHART_TYPE_LINE_CHART;
export const DEFAULT_DASHBOARD_CHART_TYPE = HomeCard.ChartType.CHART_TYPE_NAME;
export const DEFAULT_HEATMAP_CHART_TYPE = HomeCard.ChartType.CHART_TYPE_HEATMAP;
